/**
 * Detekter om nettleseren er på "landing"-domenet (krafthub.no) eller
 * "app"-domenet (app.krafthub.no). Bruker i App.js for å velge hva
 * `/` viser og om Landing i det hele tatt skal være tilgjengelig.
 */
export const APP_HOSTS = new Set([
  "app.krafthub.no",
  "app.krafthub.no.",
  "app.krafthub.eu",
  "app.krafthub.eu.",
]);

// krafthub.no + krafthub.eu støtter BÅDE landingsside og app på samme domene:
// - `/` uinnlogget → landing
// - `/` innlogget → dashboard
// - `/login` → alltid login
// Derfor er de IKKE i LANDING_HOSTS (som ville låst dem til kun landing).
export const LANDING_HOSTS = new Set([
  // Reservert for framtidig ren marketing-domene, f.eks. "www.krafthub-marketing.no"
]);

/**
 * Returnerer "landing" | "app" | "dev".
 * - landing: kun landingsside + kontaktskjema, `/` viser landing uansett auth
 * - app: kun CRM, `/` → login/dashboard, ingen landingsside
 * - dev: fallback (preview, localhost) — app-modus men landing tilgjengelig på /velkommen
 */
export function getHostMode() {
  if (typeof window === "undefined") return "app";
  const h = window.location.hostname.toLowerCase();
  if (LANDING_HOSTS.has(h)) return "landing";
  if (APP_HOSTS.has(h)) return "app";
  return "dev";
}
